import './userPanelTableLoading.css';

function UserPanelTableLoading({
  rows = 5,
  columns = 4,
  label = 'Kayıtlar yükleniyor',
  className = '',
}) {
  const safeRows = Math.max(1, Number(rows) || 1);
  const safeColumns = Math.max(1, Number(columns) || 1);

  return (
    <div
      className={`tvup-table-loading${className ? ` ${className}` : ''}`}
      role="status"
      aria-live="polite"
      aria-label={label}
      style={{ '--tvup-table-loading-columns': safeColumns }}
    >
      <div className="tvup-table-loading-rows" aria-hidden="true">
        {Array.from({ length: safeRows }, (_, rowIndex) => (
          <span className="tvup-table-loading-row" key={`loading-row-${rowIndex}`}>
            {Array.from({ length: safeColumns }, (_, columnIndex) => (
              <i key={`loading-cell-${rowIndex}-${columnIndex}`} />
            ))}
          </span>
        ))}
      </div>
    </div>
  );
}

export default UserPanelTableLoading;
